import { render } from "./WCCartDrawerItemText.vue?vue&type=template&id=d81fb426&scoped=true"
import script from "./WCCartDrawerItemText.vue?vue&type=script&lang=js"
export * from "./WCCartDrawerItemText.vue?vue&type=script&lang=js"

import "./WCCartDrawerItemText.vue?vue&type=style&index=0&id=d81fb426&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d81fb426"]])

export default __exports__